import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Radio,
  TextField,
  Button,
} from '@material-ui/core'
import { validateEmailAddress } from '../../helpers/validation'

const SendToManagerModal = ({ open, onClose, participants, handleSubmit }) => {
  const [selectedParticipant, setSelectedParticipant] = useState(null)
  const [emailErrors, setEmailErrors] = useState({})
  const [participantList, setParticipantList] = useState(
    Array.isArray(participants) ? participants : []
  )
  const [emailChanged, setEmailChanged] = useState(false)

  const handleEmailChange = (id, value) => {
    setParticipantList(prev =>
      prev.map(p => {
        if (p.id === id) {
          const isValidEmail = validateEmailAddress(value)
          setEmailErrors(prevErrors => ({
            ...prevErrors,
            [id]: !isValidEmail,
          }))
          return { ...p, personEmail: value }
        }
        return p
      })
    )

    setSelectedParticipant(prev => ({
      ...prev,
      personEmail: value,
    }))
    setEmailChanged(true)
  }

  const handleRadioChange = id => {
    const selected = participantList.find(p => p.id === id)
    setSelectedParticipant(selected)
    const isEmailValid = validateEmailAddress(selected.personEmail)
    setEmailErrors({ [id]: !isEmailValid })
  }

  useEffect(() => {
    setParticipantList(participants || [])
  }, [participants])

  useEffect(() => {
    if (participantList?.length > 0 && !emailChanged) {
      const selected = participantList.find(c => c.emailRecipientType === 'To')

      if (!selected) return

      setSelectedParticipant(selected)
      const isEmailValid = validateEmailAddress(selected.personEmail)
      setEmailErrors({ [selected.id]: !isEmailValid })
    }
  }, [participantList])

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='lg'>
      <DialogTitle>Select Email Recipient</DialogTitle>
      <DialogContent>
        {participantList?.length === 0 ? (
          <p style={{ textAlign: 'center' }}>No participants found.</p>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Relationship</TableCell>
                  <TableCell>Select</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(participantList) &&
                  participantList.map(p => (
                    <TableRow key={p.id}>
                      <TableCell aria-label='Person name'>
                        {p.personName}
                      </TableCell>

                      <TableCell>
                        <TextField
                          inputProps={{ 'aria-label': 'Email' }}
                          type='email'
                          value={p.personEmail || ''}
                          onChange={e =>
                            handleEmailChange(p.id, e.target.value)
                          }
                          fullWidth
                          error={emailErrors[p.id]}
                          helperText={
                            emailErrors[p.id] ? 'Invalid email address' : ''
                          }
                        />
                      </TableCell>
                      <TableCell aria-label='Role'>
                        {p.participantRole}
                      </TableCell>
                      <TableCell aria-label='Relationship'>
                        {p.participantRelation}
                      </TableCell>
                      <TableCell aria-label='Radio button'>
                        <Radio
                          inputProps={{ 'aria-label': 'Radio button' }}
                          checked={selectedParticipant?.id === p.id}
                          onChange={() => handleRadioChange(p.id)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='secondary'>
          Cancel
        </Button>
        <Button
          onClick={() => {
            const participant = participantList.find(
              c => c.id === selectedParticipant.id
            )
            selectedParticipant.personEmail = participant.personEmail
            handleSubmit(selectedParticipant)
          }}
          color='primary'
          disabled={
            !selectedParticipant || emailErrors[selectedParticipant?.id]
          }>
          Next
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SendToManagerModal
